import React, {useEffect, useState} from 'react';
import moment from "moment";
import {FormattedMessage} from "react-intl";
import ContestPickStatus from "../ContestPickStatus/ContestPickStatus";
import GlobalConst from "../../constants/GlobalConst";

import "./ContestPick.style.scss"
import {useSelector} from "react-redux";
import {selectLocale} from "../../stores/account/account.selectors";
import {getTeamShortName} from "../../utils/SportUtils";
import useContestModal from "../../hooks/useContestModal";
import {selectGameById, selectPlayerById, selectPlayerStatsById} from "../../stores/sports/sports.selectors";
import GameMatchUpInfo from "../GameMatchUpInfo/GameMatchUpInfo";
import {getStartTime} from "../../utils/timeUtils";
import {SeasonsAbvrMap} from "../../constants/SportsConst";

const ContestPick = ({parlay, contest, showRemoveButton, disabled}) => {
    let pictureUrl = `${GlobalConst.CDN.BASEURL}images/Players/${GlobalConst.LEAGUES_BY_SPORT_ID[contest?.SportId]}/${contest?.PlayerId}.png`;
    const locale = useSelector(selectLocale);
    const game = useSelector(state=>selectGameById(state, contest?.GameId));
    const player = useSelector(state=>selectPlayerById(state, contest?.PlayerId));

    const openContestModal = useContestModal();

    //const playerStats = useSelector(state=>selectPlayerStatsById(state, contest?.PlayerId, contest?.GameId ));
    //const teamKey = getTeamShortName(player?.TeamId, GlobalConst.LEAGUES_BY_SPORT_ID[contest.SportId]+"Player");
    const isGameStarted = game?.GL < 1;
    const isGameLive = game?.GL % 1 > 0;
    const isGameClosed = game?.GL === 0;

    const [previousLineValue, setPreviousLineValue] = useState(null);
    const [lineValueDirection, setLineValueDirection] = useState(null);

    let lineValue = parlay.ContestsPicks[contest.Id]?.LineValue;
    if( !isGameStarted )
        lineValue = contest.LineValue;

    useEffect(() => {
        if (previousLineValue !== null) {
            setLineValueDirection(lineValue > previousLineValue ? 'Up' : 'Down');

            const timer = setTimeout(() => {
                setLineValueDirection(null);
            }, 3000);

            return () => clearTimeout(timer);
        }
        setPreviousLineValue(lineValue);
    }, [lineValue]);

    const handlePlayerClick = () => {
        openContestModal({...contest, player});
    };

    return (
        <div className="ContestPick">
            <div className="playerCol"
                 onClick={() => {
                handlePlayerClick();
            }}>
                <div className="playerImage" style={{backgroundImage:`url(${pictureUrl})`}}>
                    {isGameLive && <div className="live-icon"/>}
                    {isGameClosed && <div className="closed-icon"/>}
                </div>
                <div className="playerInfo">
                    <div className={"playerName"}>
                        {contest?.Name[locale]} <span className={"team"}>{" - "}{player.Position}</span>
                    </div>
                    <div className={"opponent"}>
                         <span className={"vs"}><GameMatchUpInfo playerTeamId={player?.TeamId}
                                                                 awayTeamKey={game?.AwayTeamKey}
                                                                 awayTeamId={game?.AwayTeamId}
                                                                 homeTeamKey={game?.HomeTeamKey}
                                                                 homeTeamId={game?.HomeTeamId} />{" - "}{`${getStartTime(moment(game?.DateTime), locale)}`}</span>
                        {contest.SeasonId && <span className="season">&nbsp;( {SeasonsAbvrMap[contest.SeasonId]} )</span>}
                    </div>
                    <div className={"playerStats"}>
                        <span className={`stat ${lineValueDirection ? `lineValue${lineValueDirection}`: 'gold-gradient-text'}`}>{lineValue} <FormattedMessage id={`StatsKeys.${contest.SportId}.${contest.StatsKey}.lineValueUnit`} />
                        </span>
                    </div>
                </div>
            </div>
            {isGameStarted && <div className="statsValue gold-gradient-text">
                                {parseFloat(contest.StatsValue).toFixed(contest.SportId === GlobalConst.SPORTS_IDS.BASKETBALL ? 0 : 1)} <FormattedMessage id={`StatsKeys.${contest.SportId}.${contest.StatsKey}.statsValueUnitAbbr`} />
                            </div>}
            <div className="action">
                <ContestPickStatus disableBtn={isGameStarted || disabled}
                                   contest={contest}
                                   parlay={parlay}
                                   showRemoveButton={showRemoveButton}
                                   isGameStarted={isGameStarted}
                />
            </div>
        </div>
    );
};

export default ContestPick;